import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { CardForm } from '@/components/forms'
import { AuthorizationFormData } from '@/types/forms'

interface CardsFormProps {
    control: Control<AuthorizationFormData>
    text: string
    isDisabled?: boolean
}

export const CardsForm = ({
    control,
    text,
    isDisabled
}: CardsFormProps): JSX.Element => {
    const { t } = useTranslation()

    const newText = `${text}.PersonalData`

    return (
        <div>
            <CardForm
                nameControl="acceptDataProcessing"
                nameControl2="acceptSensitiveData"
                title={t(`${newText}.title`)}
                description={t(`${newText}.description`)}
                article={[
                    {
                        subtitle: t(`${newText}.subtitle`),
                        text: [t(`${newText}.text`)]
                    },
                    {
                        subtitle: t(`${newText}.subtitle2`),
                        text: [t(`${newText}.text2`)]
                    },
                    {
                        subtitle: t(`${newText}.subtitle3`),
                        text: [t(`${newText}.text3`)]
                    },
                    {
                        subtitle: t(`${newText}.subtitle4`),
                        text: [t(`${newText}.text4`)]
                    },
                    {
                        subtitle: t(`${newText}.subtitle5`),
                        text: [t(`${newText}.text5`)],
                        list: [
                            t(`${newText}.list1`),
                            t(`${newText}.list2`),
                            t(`${newText}.list3`),
                            t(`${newText}.list4`),
                            t(`${newText}.list5`),
                            t(`${newText}.list6`),
                            t(`${newText}.list7`),
                            t(`${newText}.list8`),
                            t(`${newText}.list9`)
                        ]
                    },
                    {
                        subtitle: t(`${newText}.subtitle6`),
                        text: [t(`${newText}.text6`)]
                    },
                    {
                        subtitle: t(`${newText}.subtitle7`),

                        list: [
                            t(`${newText}.list10`),
                            t(`${newText}.list11`),
                            t(`${newText}.list12`)
                        ]
                    },
                    {
                        text: [
                            t(`${newText}.text7`),
                            t(`${newText}.text8`),
                            t(`${newText}.text9`)
                        ],
                        list: [
                            t(`${newText}.list13`),
                            t(`${newText}.list14`),
                            t(`${newText}.list15`),
                            t(`${newText}.list16`)
                        ]
                    }
                ]}
                inputCategory={3}
                acceptTerms={[
                    t(`${newText}.acceptTerms`),
                    t(`${newText}.acceptTerms2`)
                ]}
                required={t(`${newText}.required`)}
                control={control}
                isDisabled={isDisabled}
            />
            <CardForm
                title={t(`${text}.Notifications.title`)}
                description={t(`${text}.Notifications.description`)}
                nameControl="acceptEmailNotifications"
                acceptTerms={[t(`${text}.Notifications.acceptTerms`)]}
                required={t(`${text}.Notifications.required`)}
                control={control}
                isDisabled={isDisabled}
            />
        </div>
    )
}
